import{__exports as e}from"../../../../_virtual/version2.js";Object.defineProperty(e,"__esModule",{value:!0}),e.LIB_VERSION=void 0,e.LIB_VERSION="3.7.1";export{e as default};
